import {
  API_PATH,
  ROOT_PATH,
  USER_DETAILS,
  CART_DETAILS,
  CURRENCY_DETAILS,
  DESTINATIONS,
  SEARCH_RESULT,
  SEARCH_WHOLE_SITE,
  SEARCH_LOADING,
  CATEGORY,
  LOCATION_SEARCH_RESULT,
  SEARCH_API_PATH,
  ADD_ACTIVITY,
  CONTENT_LOADER,
  PAGE_LOADER,
  LOAD_ACTIVITY,
  OFFSET_INCREMENT,
  RESET_OFFSET,
  QUERY_STRING,
  SELECTED_CATEGORY,
  QUERY_STRING_LOCATION,
  QUERY_STRING_CATEGORY,
  QUERY_STRING_DATE,
  QUERY_STRING_PRICE,
  QUERY_STRING_SORT,
  LMS_LOADING,
  LMS_LIST_CATEGORIES,
  LMS_CURRENT_MODAL,
  LMS_QUERY_DETAILS,
  LMS_ACTIVITY_DETAILS,
  LMS_LOAD_LOCATIONS,
  LMS_SHOW_SEARCH_RESULT,
  LMS_MEMBER_DETAILS,
  LMS_USER_DETAILS,
  LMS_SET_OTP,
  LMS_USER_DATA,
  LMS_ROOT,
  LMS_API_PATH,
  QUERY_STRING_DURATION,
  QUERY_STRING_TOUR_TYPE
} from "./constant";

export function loadUserDetails(user) {
  return {
    type: USER_DETAILS,
    payload: user
  };
}

export function loadCartDetails(cart) {
  return {
    type: CART_DETAILS,
    payload: cart
  };
}

export function loadCurrencyDetails(currency) {
  return {
    type: CURRENCY_DETAILS,
    payload: currency
  };
}
export function loadDestinations(destinations) {
  return {
    type: DESTINATIONS,
    payload: destinations
  };
}
export function searchResult(result) {
  return {
    type: SEARCH_RESULT,
    payload: result
  };
}

export function searchLoading(bool) {
  return {
    type: SEARCH_LOADING,
    payload: bool
  };
}

export function loadCategory(categories) {
  return {
    type: CATEGORY,
    payload: categories
  };
}

export function loadLocations(locations) {
  return {
    type: LOCATION_SEARCH_RESULT,
    payload: locations
  };
}

export function addActivities(activities) {
  return {
    type: ADD_ACTIVITY,
    payload: activities
  };
}
export function contentLoading(bool) {
  return {
    type: CONTENT_LOADER,
    payload: bool
  };
}
export function pageLoading(bool) {
  return {
    type: PAGE_LOADER,
    payload: bool
  };
}
export function loadActivities(activities, count) {
  return {
    type: LOAD_ACTIVITY,
    payload: {
      activities,
      count
    }
  };
}
export function incrementOffset() {
  return {
    type: OFFSET_INCREMENT
  };
}

export function resetOffset() {
  return {
    type: RESET_OFFSET
  };
}

export function loadQueryString(queryString) {
  return {
    type: QUERY_STRING,
    payload: queryString
  };
}
export function updateSelectedCategory(categoryLink) {
  return {
    type: SELECTED_CATEGORY,
    payload: categoryLink
  };
}

export function queryStringLocation(location) {
  return {
    type: QUERY_STRING_LOCATION,
    payload: location
  };
}

export function queryStringCategory(category, name) {
  return {
    type: QUERY_STRING_CATEGORY,
    payload: {
      type: category,
      name: name
    }
  };
}
export function queryStringDate(date) {
  return {
    type: QUERY_STRING_DATE,
    payload: date
  };
}
export function queryStringPrice(price) {
  return {
    type: QUERY_STRING_PRICE,
    payload: price
  };
}
export function queryStringSort(sort) {
  return {
    type: QUERY_STRING_SORT,
    payload: sort
  };
}

export function queryStringDuration(duration) {
  return {
    type: QUERY_STRING_DURATION,
    payload: duration
  };
}

export function updateQueryString(query) {
  return dispatch => {
    let location = {};
    if (query.countryId) {
      location.id = query.countryId;
      location.name = cleanUrlNames(query.countryName);
      location.category = "Country";
    } else if (query.stateId) {
      location.id = query.stateId;
      location.name = cleanUrlNames(query.stateName);
      location.category = "State";
    } else if (query.locationId) {
      location.id = query.locationId;
      if (query.destination) location.name = cleanUrlNames(query.destination);
      else if (query.location) location.name = cleanUrlNames(query.location);
      location.category = "";
    }
    dispatch(queryStringCategory(query.type, ""));
    dispatch(queryStringDate({
      to: query.to,
      from: query.from
    }));
    dispatch(queryStringPrice({
      from: query.priceFrom,
      to: query.priceTo
    }));
    dispatch(queryStringTourType(query.tourType));
    dispatch(queryStringLocation(location));
    dispatch(queryStringDuration(query.duration));
    return dispatch(queryStringSort({
      sort: query.sort,
      order: query.order
    }));
  };
}

export function queryStringTourType(tourType) {
  return {
    type: QUERY_STRING_TOUR_TYPE,
    payload: tourType
  };
}

export function updateQueryStringForLocation(queryString, category, id, destination) {
  return dispatch => {
    let q = {};
    if (category === "State") {
      if (queryString.locationId) delete queryString.locationId;
      queryString.stateId = id;
    } else {
      if (queryString.stateId) delete queryString.stateId;
      queryString.locationId = id;
    }
    queryString.destination = destination;
    q = { ...queryString
    };
    dispatch(loadLocations([]));
    return dispatch(loadQueryString(q));
  };
}

export const getSessionDetails = () => {
  return dispatch => {
    return fetch(API_PATH + "get-user-details.php", {
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) {
          dispatch(loadCartDetails(data.payload.cart));
          dispatch(loadCurrencyDetails(data.payload.currency));
          dispatch(loadDestinations(data.payload.destinations));
          return dispatch(loadUserDetails(data.payload.user));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export function removeFromCart(id, type) {
  let data = new FormData();
  data.append("id", id);
  data.append("type", type);

  return dispatch => {
    return fetch(API_PATH + "remove-from-cart.php", {
        method: "POST",
        credentials: "same-origin",
        body: data
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) {
          return dispatch(loadCartDetails(data.payload));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function changeCurrency(code, curr) {
  console.log("MAK:: currency change function ", code, curr);
  let data = new FormData();
  data.append("code", code);
  data.append("curr", curr);
  return dispatch => {
    return fetch(ROOT_PATH + "ajax/changeCurrency.php", {
        method: "POST",
        credentials: "same-origin",
        body: data
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        window.location.reload();
        return;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function logout() {
  return dispatch => {
    return fetch(API_PATH + "logout.php", {
        method: "POST",
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        window.location.reload();
        return;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function searchWholePage(term, category) {
  return dispatch => {
    dispatch(searchLoading(true));
    return fetch(SEARCH_WHOLE_SITE + "?term=" + term + "&category=" + category, {
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        dispatch(searchResult(data));
        return dispatch(searchLoading(false));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export const getCategoryList = (locationId = 0) => {
  return dispatch => {
    return fetch(API_PATH + "get-category-list.php?locationId=" + locationId, {
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) {
          return dispatch(loadCategory(data.payload));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export function fetchLocations(location) {
  return dispatch => {
    dispatch(searchLoading(true));
    return fetch(SEARCH_API_PATH + location, {
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        dispatch(loadLocations(data));
        return dispatch(searchLoading(false));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export const fetchActivities = (queryString, fetchMore) => {
  console.log("fetch activities ", queryString, fetchMore);
  return dispatch => {
    dispatch(contentLoading(true));
    if (!fetchMore) {
      dispatch(pageLoading(true));
    }
    return fetch(API_PATH + "get-activities.php?" + queryString, {
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) {
          dispatch(pageLoading(false));
          if (fetchMore) {
            dispatch(addActivities(data.payload.activities));
            return setTimeout(() => {
              dispatch(contentLoading(false));
            }, 1000);
          } else {
            dispatch(loadActivities(data.payload.activities, parseInt(data.payload.count, 10)));
            return setTimeout(() => {
              dispatch(contentLoading(false));
              dispatch(pageLoading(false));
            }, 1000);
          }
        } else {
          console.log("status false ", data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function parseJSON(response) {
  return response.json();
}

//LMS

export function lms_loading(bool) {
  return {
    type: LMS_LOADING,
    payload: bool
  };
}

export function lms_loadCategories(category) {
  return {
    type: LMS_LIST_CATEGORIES,
    payload: category
  };
}
export function lms_updateCurrentModal(modal) {
  return {
    type: LMS_CURRENT_MODAL,
    payload: modal
  };
}

export function lms_updateQueryDetails(queryType, id, dateType, startDate, endDate, category) {
  return {
    type: LMS_QUERY_DETAILS,
    payload: {
      queryType,
      id,
      dateType,
      startDate,
      endDate,
      category
    }
  };
}

export function lms_setActivityDetails(id, name) {
  return {
    type: LMS_ACTIVITY_DETAILS,
    payload: {
      id: id,
      name: name
    }
  };
}
export function lms_storeQueryDetails(queryType, id, dateType, startDate, endDate, category) {
  return dispatch => {
    dispatch(lms_updateQueryDetails(queryType, id, dateType, startDate, endDate, category));
  };
}

export function lms_storeLocationSearchResult(data) {
  return {
    type: LMS_LOAD_LOCATIONS,
    payload: data
  };
}

export function lms_showSearchResult(bool) {
  return {
    type: LMS_SHOW_SEARCH_RESULT,
    payload: bool
  };
}

export function lms_updateMemberDetails(adPax, chPax, comment) {
  return {
    type: LMS_MEMBER_DETAILS,
    payload: {
      adPax,
      chPax,
      comment
    }
  };
}
export function lms_updateUserDetails(name, email, phone) {
  return {
    type: LMS_USER_DETAILS,
    payload: {
      name,
      email,
      phone
    }
  };
}

export function lms_setOTP(code) {
  return {
    type: LMS_SET_OTP,
    payload: code
  };
}

export function lms_setUserData(user) {
  return {
    type: LMS_USER_DATA,
    payload: user
  };
}
export function lms_searchDetination(dest) {
  let url = LMS_ROOT + "ajax/vendors/activity/suggestLocation.php?term=";

  return dispatch => {
    return fetch(url + dest)
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        dispatch(lms_showSearchResult(true));
        return dispatch(lms_storeLocationSearchResult(data));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function lms_fetchCategoryList() {
  let url = LMS_API_PATH + "getCategories.php";
  return dispatch => {
    dispatch(lms_showSearchResult(false));
    return fetch(url)
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) return dispatch(lms_loadCategories(data.payload));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function lms_sendOTP(phone, countryCode) {
  let url = LMS_API_PATH + "sendOTPToNumber.php";
  let data = new FormData();
  data.append("number", phone);
  data.append("countryCode", countryCode);
  return dispatch => {
    return fetch(url, {
        method: "POST",
        body: data
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        return dispatch(lms_setOTP(data.code));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export function lms_getUserData(id) {
  let url = LMS_API_PATH + "getUserData.php";
  let data = new FormData();
  data.append("id", id);

  return dispatch => {
    return fetch(url, {
        method: "POST",
        body: data,
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        if (data.status) {
          return dispatch(lms_setUserData(data.payload));
        } else {
          return dispatch(
            lms_setUserData({
              name: "",
              email: ""
            })
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}
export function lms_registerEnquiry(name, email, phone, all, countryCode) {
  let url = LMS_API_PATH + "registerEnquiry.php";
  let data = new FormData();
  data.append("source", all.activityDetails.id);
  data.append("name", name);
  data.append("email", email);
  data.append("phone", phone);
  data.append("countryCode", countryCode);

  data.append("dateType", all.queryDetails.dateType);
  data.append("startDate", all.queryDetails.startDate);
  data.append("endDate", all.queryDetails.endDate);
  data.append("queryType", all.queryDetails.queryType);
  data.append("id", all.queryDetails.id);
  data.append("nrAdults", all.memberDetaisl.adPax);
  data.append("nrChild", all.memberDetaisl.chPax);
  data.append("comment", all.memberDetaisl.comment);
  data.append("category", all.queryDetails.category);

  return dispatch => {
    return fetch(url, {
        method: "POST",
        body: data,
        credentials: "same-origin"
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(function (data) {
        return dispatch(lms_updateCurrentModal("THANK_YOU"));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

/**
 * @param string
 * @return string removed - with spaces and capitalize string
 */
function cleanUrlNames(str) {
  if(str){
    str = str.replace(/-/gi, " ");
    str = str.replace(/^\w/, c => c.toUpperCase());
  }
  return str;
}
